import {
	ClockCircleOutlined,
	CheckOutlined,
	UsergroupDeleteOutlined,
	RocketOutlined,
	NotificationFilled,
	TrophyFilled,
	SubnodeOutlined,
	CalendarOutlined,
	FileDoneOutlined,
	PieChartFilled,
	FileOutlined,
	FlagFilled,
	HomeOutlined,
	SettingOutlined,
	UnorderedListOutlined,
	UsergroupAddOutlined,
	UserOutlined,
	UserSwitchOutlined,
	WalletOutlined,
	FileSyncOutlined,
	FlagOutlined,
	FileTextOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

import getPermissions from "../../utils/getPermissions";
import getUserFromToken from "../../utils/getUserFromToken";
// import styles from "./Sidenav.module.css";



const Sidenav = ({ color, sideNavOpenKeys }) => {
	const user = getUserFromToken();
	const role = (localStorage.getItem("role") || user?.role || "").toLowerCase();
	const permissions = getPermissions();
	const hasPermission = () => true;
	

	// console.log("haspermission", hasPermission("create-user"));
	const menu = [
		{
			label: (
				<NavLink to={role === "admin" ? "/admin/dashboard" : "/user/dashboard"}>
					<span>Dashboard</span>
				</NavLink>
			),
			key: "dashboard",
			icon: <HomeOutlined />,
		},

		role === "admin" &&
		(hasPermission("create-user") ||
			hasPermission("readAll-user") ||
			hasPermission("readAll-role") ||
			hasPermission("readAll-designation") ||
			hasPermission("readAll-department")) && {
			label: "HR",
			key: "hr",
			icon: <UserOutlined />,
			children: [
				hasPermission("create-user") && {
					label: (
						<NavLink to='/admin/hr/staffs/new'>
							<span>New Employee</span>
						</NavLink>
					),

					key: "staffs",
					icon: <UsergroupAddOutlined />,
				},
				hasPermission("readAll-user") && {
					label: (
						<NavLink to='/admin/hr/staffs'>
							<span>Employee List</span>
						</NavLink>
					),
					key: "users",
					icon: <UsergroupAddOutlined />,
				},
				hasPermission("readAll-role") && {
					label: (
						<NavLink to='/admin/role'>
							<span>Role & Permissions</span>
						</NavLink>
					),
					key: "roleAndPermissions",
					icon: <UserSwitchOutlined />,
				},
				hasPermission("readAll-designation") && {
					label: (
						<NavLink to='/admin/designation/'>
							<span>Designation</span>
						</NavLink>
					),
					key: "designation",
					icon: <UserSwitchOutlined />,
				},
				hasPermission("readAll-department") && {
					label: (
						<NavLink to='/admin/department'>
							<span>Department</span>
						</NavLink>
					),
					key: "department",
					icon: <UserSwitchOutlined />,
				},
			],
		},
		role === "admin" &&
		(hasPermission("create-attendance") ||
			hasPermission("readAll-attendance")) && {
			label: "ATTENDANCE",
			key: "attendanceMain",
			icon: <ClockCircleOutlined />,
			children: [
				hasPermission("create-attendance") && {
					label: (
						<NavLink to='/admin/attendance'>
							<span>Attendance</span>
						</NavLink>
					),
					key: "attendance",
					icon: <FileDoneOutlined />,
				},
				hasPermission("readSingle-attendance") && {
					label: (
						<NavLink to={`/admin/attendance/user/${user}`}>
							<span>My Attendance</span>
						</NavLink>
					),
					key: "myAttendance",
					icon: <FileDoneOutlined />,
				},
			],
		},
		role === "admin" &&
		(hasPermission("create-payroll") || hasPermission("readAll-payroll")) && {
			label: "PAYROLL",
			key: "payroll",
			icon: <WalletOutlined />,
			children: [
				hasPermission("create-payroll") && {
					label: (
						<NavLink to='/admin/payroll/new'>
							<span>Calculate Payroll</span>
						</NavLink>
					),
					key: "calculatePayroll",
					icon: <FileDoneOutlined />,
				},
				hasPermission("readAll-payroll") && {
					label: (
						<NavLink to='/admin/payroll/list'>
							<span>Payslip List</span>
						</NavLink>
					),
					key: "payslipList",
					icon: <FileOutlined />,
				},
			],
		},
		role === "admin" &&
		hasPermission("readAll-shift") && {
			label: "SHIFT",
			key: "shift",
			icon: <ClockCircleOutlined />,
			children: [
				hasPermission("readAll-shift") && {
					label: (
						<NavLink to='/admin/shift'>
							<span>Shift</span>
						</NavLink>
					),
					key: "newShift",
					icon: <FileDoneOutlined />,
				},
			],
		},
		role === "admin" &&
		hasPermission("readAll-employmentStatus") && {
			label: "EMPLOYEMENT",
			key: "employementStatus",
			icon: <RocketOutlined />,
			children: [
				hasPermission("readAll-employmentStatus") && {
					label: (
						<NavLink to='/admin/employment-status'>
							<span>Status</span>
						</NavLink>
					),
					key: "employementStatus",
					icon: <FileDoneOutlined />,
				},
			],
		},
		role === "admin" &&
		(hasPermission("create-leaveApplication") ||
			hasPermission("readAll-leaveApplication") ||
			hasPermission("readSingle-leaveApplication")) && {
			label: "LEAVE ",
			key: "leave",
			icon: <UsergroupDeleteOutlined />,
			children: [
				hasPermission("create-leaveApplication") && {
					label: (
						<NavLink to='/admin/leave/new'>
							<span> New Leave </span>
						</NavLink>
					),
					key: "newLeave",
					icon: <SubnodeOutlined />,
				},
				hasPermission("readAll-leaveApplication") && {
					label: (
						<NavLink to='/admin/leave'>
							<span>Leave Status</span>
						</NavLink>
					),
					key: "leaveStatus",
					icon: <FileDoneOutlined />,
				},
				hasPermission("readSingle-leaveApplication") && {
					label: (
						<NavLink to={`/admin/leave/user/${user}`}>
							<span>My Leaves</span>
						</NavLink>
					),
					key: "myLeaves",
					icon: <FileDoneOutlined />,
				},
			],
		},
		role === "admin" &&
		(hasPermission("readAll-weeklyHoliday") ||
			hasPermission("readAll-publicHoliday")) && {
			label: "HOLIDAY",
			key: "holiday",
			icon: <CalendarOutlined />,
			children: [
				hasPermission("readAll-weeklyHoliday") && {
					label: (
						<NavLink to='/admin/holiday/week'>
							<span>Weekly Holiday</span>
						</NavLink>
					),
					key: "weeklyHoliday",
					icon: <PieChartFilled />,
				},
				hasPermission("readAll-publicHoliday") && {
					label: (
						<NavLink to='/admin/holiday/public'>
							<span>Public Holiday</span>
						</NavLink>
					),
					key: "publicHoliday",
					icon: <PieChartFilled />,
				},
			],
		},
		role === "admin" &&
		hasPermission("readAll-leavePolicy") && {
			label: "LEAVE POLICY",
			key: "leavePolicy",
			icon: <CalendarOutlined />,
			children: [
				hasPermission("readAll-leavePolicy") && {
					label: (
						<NavLink to='/admin/leave-policy'>
							<span>Leave Policy</span>
						</NavLink>
					),
					key: "leavePolicy",
					icon: <PieChartFilled />,
				},
			],
		},
		role === "admin" &&
		hasPermission("readAll-announcement") && {
			label: "ANNOUNCEMENT",
			key: "announcement",
			icon: <NotificationFilled />,
			children: [
				hasPermission("readAll-announcement") && {
					label: (
						<NavLink to='/admin/announcement'>
							<span>Announcement</span>
						</NavLink>
					),
					key: "newLeave",
					icon: <FlagFilled />,
				},
			],
		},
		role === "admin" &&
		(hasPermission("readAll-account") ||
			hasPermission("readAll-transaction") ||
			hasPermission("create-transaction")) && {
			label: "ACCOUNTS",
			key: "accounts",
			icon: <WalletOutlined />,
			children: [
				hasPermission("readAll-account") && {
					label: (
						<NavLink to='/admin/account/'>
							<span>Account</span>
						</NavLink>
					),
					key: "accountList",
					icon: <UnorderedListOutlined />,
				},
				hasPermission("create-transaction") && {
					label: (
						<NavLink to='/admin/transaction/create'>
							<span>New Transaction</span>
						</NavLink>
					),
					key: "newTransaction",
					icon: <CheckOutlined />,
				},
				hasPermission("readAll-transaction") && {
					label: (
						<NavLink to='/admin/transaction/'>
							<span>Transaction List</span>
						</NavLink>
					),
					key: "transactionList",
					icon: <UnorderedListOutlined />,
				},
			],
		},
		role === "admin" &&
		hasPermission("readAll-account") && {
			label: "FINANCE REPORT",
			key: "report",
			icon: <FlagOutlined />,
			children: [
				hasPermission("readAll-account") && {
					label: (
						<NavLink to='/admin/account/trial-balance'>
							<span>Trial Balance</span>
						</NavLink>
					),
					key: "trialBalance",
					icon: <FileDoneOutlined />,
				},
				hasPermission("readAll-account") && {
					label: (
						<NavLink to='/admin/account/balance-sheet'>
							<span>Balance Sheet</span>
						</NavLink>
					),
					key: "balanceSheet",
					icon: <FileOutlined />,
				},
				hasPermission("readAll-account") && {
					label: (
						<NavLink to='/admin/account/income'>
							<span>Income Statement</span>
						</NavLink>
					),
					key: "incomeStatement",
					icon: <FileSyncOutlined />,
				},
			],
		},
		role === "admin" &&
		(hasPermission("create-award") || hasPermission("readAll-award")) && {
			label: "AWARDS",
			key: "award",
			icon: <TrophyFilled />,
			children: [
				hasPermission("create-award") && {
					label: (
						<NavLink to='/admin/award/new'>
							<span>New Award</span>
						</NavLink>
					),
					key: "newAward",
					icon: <TrophyFilled />,
				},

				hasPermission("readAll-award") && {
					label: (
						<NavLink to='/admin/award'>
							<span>Award</span>
						</NavLink>
					),
					key: "award",
					icon: <TrophyFilled />,
				},
			],
		},

		{
			label: "PROJECT MANAGEMENT",
			key: "projectManagement",
			icon: <SettingOutlined />,
			children: [
				{
					label: (
						<NavLink to="/admin/clients">
							<span>Clients</span>
						</NavLink>
					),
					key: "clients",
					icon: <UnorderedListOutlined />,
				},
				{
					label: (
						<NavLink to="/admin/projects">
							<span>Projects</span>
						</NavLink>
					),
					key: "projects",
					icon: <FileOutlined />,
				},
				{
					label: "Reports",
					key: "reports",
					icon: <FileOutlined />,
					children: [
						{
							label: (
								<NavLink to="/admin/reports/project-list">
									<span>Project List</span>
								</NavLink>
							),
							key: "projectList",
						},
						{
							label: (
								<NavLink to="/admin/reports/team-member">
									<span>Team Member</span>
								</NavLink>
							),
							key: "teamMember",
						},
					],
				},
				{
					label: (
						<NavLink to="/admin/manage-task">
							<span>Manage Task</span>
						</NavLink>
					),
					key: "manageTask",
					icon: <UnorderedListOutlined />,
				},
			],
		},


		// ✅ ADD THIS NEW BLOCK (separate menu)
		{
  			label: (
    			<NavLink to="/timesheet">
      				<span>Timesheet</span>
    			</NavLink>
  			),
  			key: "timesheet",
  			icon: <FileTextOutlined />,
		},

		{
  			label: "INVOICE",
  			key: "invoice",
  			icon: <FileTextOutlined />,
  			children: [
    			{
      			label: (
        			<NavLink to={role === "admin" ? "/admin/invoice/attendance" : "/user/invoice/attendance"}>
          				<span>Attendance</span>
        			</NavLink>
      			),
      			key: "invoiceAttendance",
      			icon: <ClockCircleOutlined />,
    			},
    			{
      			label: (
        			<NavLink to={role === "admin" ? "/admin/invoice" : "/user/invoice/expense"}>
          				<span>Weekly Expense</span>
        			</NavLink>
      			),
      			key: "weeklyExpense",
      			icon: <WalletOutlined />,
    			},
    			{
      			label: (
        			<NavLink to={role === "admin" ? "/admin/invoice/reimbursement" : "/user/invoice/reimbursement"}>
          				<span>Reimbursement</span>
        			</NavLink>
      			),
      			key: "reimbursement",
      			icon: <FileDoneOutlined />,
    			},
  			],
		},


		// ✅ ADD THIS INSIDE YOUR SIDEBAR MENU ARRAY

		role === "admin" && {
  			label: (
  				<NavLink to="/admin/invoice-dashboard">
          			<span>Invoice Dashboard</span>
        		</NavLink>
			),
			 key: "invoiceDashboard",
  			icon: <FileOutlined />,	
    	},

		role === "admin" && {
  			label: "Notice Board",
  			key: "noticeBoard",
  			icon: <FileOutlined />,
  			children: [
    			{
      			label: (
        			<NavLink to="/admin/notice-board">
          				<span>Notice Board</span>
        			</NavLink>
      			),
      			key: "noticeBoardLink",
    			},
  			],
		},

		role === "admin" && {
  			label: "Employee",
  			key: "employeeMain",
  			icon: <FileOutlined />,
  			children: [
    			{
      			label: (
        			<NavLink to="/admin/position">
          				<span>Position</span>
        			</NavLink>
      			),
      			key: "position",
    			},
    			{
      			label: "Employee",
      			key: "employeeSub",
      			children: [
        			{
          			label: (
            			<NavLink to="/admin/position">
              				<span>Add Employee</span>
            			</NavLink>
          			),
          			key: "addEmployee",
        			},
        			{
          			label: (
            			<NavLink to="/admin/position">
              				<span>Manage Employee</span>
            			</NavLink>
          			),
          			key: "manageEmployee",
        			},
      			],
    		},
    		{
      			label: (
        			<NavLink to="/admin/position">
          				<span>Employee Performance</span>
        			</NavLink>
      			),
      			key: "employeePerformance",
    		},
  			],
		},

		role === "admin" &&
		hasPermission("readAll-setting") && {
			label: "SETTINGS",
			key: "settings",
			icon: <SettingOutlined />,
			children: [
				hasPermission("readAll-setting") && {
					label: (
						<NavLink to='/admin/company-setting'>
							<span>Company Settings</span>
						</NavLink>
					),
					key: "invoiceSetting",
					icon: <SettingOutlined />,
				},
			],
		},
	];

	return (
		<div>
			<Menu
				theme='dark'
				mode='inline'
				items={
					menu
					.filter(Boolean)
					.filter((item) => {
						if (role === "admin") return true;

						// For USER → allow only Dashboard & Project Management
						return item.key === "dashboard" || item.key === "projectManagement" || item.key === "timesheet" || item.key === "invoice";
					})
				} 
				className='sidenav-menu '
				// openKeys={[sideNavOpenKeys]}
				// style={{ backgroundColor: "transparent" }}
			/>
		</div>
	);
};

export default Sidenav;
